<template>
  <div id="rastreio_container">
    <TituloRastreio />

    <v-text-field
      v-model="codigoRastreio"
      class="mt-5"
      background-color="#FFF"
      filled
      label="Codigo rastreio"
      :error-messages="erro"
      maxlength="50"
    >
      <template slot="append-outer">
        <VueRecaptcha
          load-recaptcha-script
          :sitekey="recaptchaKey"
          @verify="setRecaptchaToken"
        >
          <v-btn
            id="btn_buscar_rastreio"
            color="primary"
            dark
            :loading="loading"
            @click="buscarRastreio"
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </VueRecaptcha>
      </template>
    </v-text-field>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import { mapActions } from 'vuex';
import apiRastreio from '@/api/rastreio';
import TituloRastreio from './TituloRastreio.vue';

export default {
  name: 'Rastreio',

  components: {
    VueRecaptcha,
    TituloRastreio,
  },

  data: () => ({
    codigoRastreio: '',
    erro: '',
    loading: false,
    recaptchaKey: process.env.VUE_APP_RECAPTCHA_KEY,
    recaptchaToken: '',
  }),

  watch: {
    codigoRastreio() {
      this.erro = '';
    },
  },

  methods: {
    ...mapActions(['buscarDadosRastreio']),

    setRecaptchaToken(token) {
      this.recaptchaToken = token;
      this.buscarRastreio();
    },

    async buscarRastreio() {
      if (!this.recaptchaToken) {
        return;
      }

      this.loading = true;

      try {
        await this.buscarDadosRastreio({
          apiRastreio,
          recaptchaToken: this.recaptchaToken,
          codigoRastreio: this.codigoRastreio,
        });

        this.$router.push(`/rastrear-envio/${this.codigoRastreio}`);
      } catch (error) {
        this.erro = error.message;
      }

      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
  #rastreio_container {
    #btn_buscar_rastreio {
      height: 57px;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }

    .v-input__append-outer {
      margin-left: 0px !important;
      margin-top: 0px !important;
    }

    .titulo {
      word-break: break-word;
      margin-top: 100px;
    }
  }
</style>
